export const metadataSerializer = (key, value) => {
  if (value instanceof Map) {
    return {
      dataType: 'Map',
      value: [...value],
    }
  } else if (value instanceof Set) {
    return {
      dataType: 'Set',
      value: [...value],
    }
  } else {
    return value
  }
}

export const metadataDeserializer = (key, value) => {
  if (typeof value === 'object' && value !== null) {
    if (value.dataType === 'Map') {
      return new Map(value.value)
    } else if (value.dataType === 'Set') {
      return new Set(value.value)
    }
  }
  return value
}